import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

const draw = (d) => ({
  initial: { pathLength: 0 },
  animate: { pathLength: 1 },
  transition: { duration: 2.2, delay: 1.4 + d, ease: [0.65, 0, 0.35, 1] },
});

export const FloorPlan = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [22, 6]), { stiffness: 80, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 80, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <div onMouseMove={onMove} onMouseLeave={reset} style={{ perspective: 900 }} data-testid="hero-floorplan">
      <motion.div
        style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        className="relative rounded-[2px] border border-[var(--ink)]/15 bg-[#F3F0EA]/90 p-5 shadow-[0_40px_80px_-30px_rgba(26,26,24,0.45)] backdrop-blur-xl"
      >
        <div className="mb-3 flex items-center justify-between">
          <span className="font-mono-d text-[11px] uppercase tracking-[0.2em] text-[var(--ink-2)]">Grundriss + Netz</span>
          <span className="font-mono-d text-[11px] text-[var(--clay-2)]">M 1:100</span>
        </div>
        <svg viewBox="0 0 300 200" className="w-full" style={{ transform: "translateZ(40px)" }}>
          <g fill="none" stroke="#1A1A18" strokeWidth="2.5">
            <motion.path d="M10 10 H290 V190 H10 Z" {...draw(0)} />
            <motion.path d="M120 10 V90 M120 120 V190 M120 110 H200 M230 110 H290" {...draw(0.3)} />
          </g>
          <g fill="none" stroke="#1A1A18" strokeWidth="1">
            <motion.path d="M120 90 A 30 30 0 0 1 150 120" strokeDasharray="3 3" {...draw(0.6)} />
            <motion.path d="M200 110 A 30 30 0 0 0 230 80" strokeDasharray="3 3" {...draw(0.7)} />
          </g>
          <g fill="none" stroke="#A85338" strokeWidth="1.5">
            <motion.path d="M60 150 L60 60 L170 60 L250 60 L250 150 M170 60 L170 150" {...draw(1)} />
          </g>
          {[[60, 150], [60, 60], [170, 60], [250, 60], [250, 150], [170, 150]].map(([x, y], i) => (
            <motion.circle key={i} cx={x} cy={y} r="4.5" fill="#A85338" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 2.6 + i * 0.08 }} />
          ))}
          <motion.rect x="150" y="45" width="40" height="30" fill="#1A1A18" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 3 }} />
          <text x="157" y="64" fill="#F3F0EA" fontSize="9" fontFamily="JetBrains Mono">CORE</text>
        </svg>
        <div className="mt-3 grid grid-cols-3 gap-2 border-t border-[var(--ink)]/10 pt-3 font-mono-d text-[11px] text-[var(--ink-2)]">
          <span>Räume</span><span>Netzwerk</span><span className="text-right">Übergabe</span>
        </div>
      </motion.div>
    </div>
  );
};
